import React from 'react';
import { Confirm, useDelete, useNotify, useRefresh } from 'react-admin';

export const PumpDeleteDialog = ({
  // @ts-ignore
  showDeleteDialog,
  // @ts-ignore
  setShowDeleteDialog,
  // @ts-ignore
  id
}) => {
  const [erase] = useDelete();
  const notify = useNotify();
  const refresh = useRefresh();
  const onCloseDeleteDialog = () => {
    setShowDeleteDialog(false);
  };

  const onDelete = () => {
    erase(
      'pumps',
      {
        id
      },
      {
        onSuccess: () => {
          notify('resources.pumps.notifications.delete.success', {
            type: 'success'
          });
          onCloseDeleteDialog();
          refresh();
        },
        onError(error: any) {
          notify(error.message, { type: 'warning' });
        }
      }
    );
  };

  return (
    <Confirm
      title="resources.pumps.delete.title"
      content="resources.pumps.delete.message"
      onConfirm={onDelete}
      isOpen={showDeleteDialog}
      onClose={onCloseDeleteDialog}
    />
  );
};
